exports.linkResolver = (doc) => {
  // URL for a product type
  if (doc.type === "product") {
    return `/produkte/${doc.uid}/`;
  }

  // URL for a page type
  if (doc.type === "product_category") {
    return `/produkte/${doc.uid}/`;
  }

  // URL for a page type
  if (doc.type === "page" && doc.uid !== "home") {
    const parent = doc.data?.parent_page;

    if (parent && parent.uid) {
      return `/${parent.uid}/${doc.uid}/`;
    }

    return `/${doc.uid}/`;
  }

  // Backup for all other types
  return "/";
};
